import { useEffect } from 'react'

import { logout } from '../../modules/apiclient'
import { Spinner } from '../Spinner'
import Heading from '../app/design/Heading'

export function Logout() {
    useEffect(() => {
        document.getElementById('root-spinner')?.remove()
        ;(async () => {
            await logout()
            window.location.href = '/login'
        })()
    }, [])

    return (
        <div className="flex h-screen flex-col items-center justify-center">
            <Heading size="xl" className="mb-4 text-center text-gray-700">
                Logging out...
            </Heading>
            <Spinner />
        </div>
    )
}
